import React from 'react';
import { InteractionLabels } from '../../../middleware/google-analytics';

import { injectKeyHandler, Keys } from '@zocdoc/components/src/KeyHandler';
import { injectSwipeHandler } from '@zocdoc/components/src/SwipeHandler';

import PictureGalleryView from './PictureGalleryView';

class PictureGalleryWrapper extends React.Component {
    render() {
        const {
            visible,
            pictures,
        } = this.props;
        if (visible && pictures && pictures.length > 0) {
            return (<PictureGalleryView {...this.props} />);
        } else {
            return (<div data-test="gallery-hidden"></div>);
        }
    }
}

export default (
    injectKeyHandler({
        [Keys.LEFT]: ({ previousPicture }) => previousPicture({ interaction: InteractionLabels.Keyboard }),
        [Keys.RIGHT]: ({ nextPicture }) => nextPicture({ interaction: InteractionLabels.Keyboard }),
    })(
        injectSwipeHandler({
            onSwipeLeft: ({ nextPicture }) => nextPicture({ interaction: InteractionLabels.Swipe }),
            onSwipeRight: ({ previousPicture }) => previousPicture({ interaction: InteractionLabels.Swipe }),
        })(
            PictureGalleryWrapper
        )
    )
);
